import React, { useEffect, useRef, useState } from 'react'
import { PreCacheItem, SinglePreCacheItem, PrecacheItemType } from '../../../../cvp-webgames-core/pre-caching/pre-cache-item';
import { AnimationState } from '../../../../cvp-webgames-core/UI/Animation/animation-base';
import { AnimationPage } from '../../../../cvp-webgames-core/UI/Animation/animation-page';
import { constants } from '../../../../misc/constants';
import { BaseConfig } from '../../../BaseConfig';
import PopUp1 from '../../../general/pop-up1';

import "./main-menu-window.css"
import { CustomGameDataManager, setFocus, setLast508WindowId, TextHtmlTagType } from '../../../../misc/tools';
import Tools from '../../../../cvp-webgames-core/Misc/Tools';

class MainMenuWindowCaching extends PreCacheItem {
	public getItems(): SinglePreCacheItem[] {
		return [
			{
				type: PrecacheItemType.Image,
				key: 'start-scenarios-bs',
				src: process.env.PUBLIC_URL + '/assets/images/main-menu/start-scenarios.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'resume-game-bs',
				src: process.env.PUBLIC_URL + '/assets/images/main-menu/resume-game.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'settings-bs',
				src: process.env.PUBLIC_URL + '/assets/images/main-menu/settings.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'reference-materials-bs',
				src: process.env.PUBLIC_URL + '/assets/images/main-menu/reference-materials.svg'
			}
		];
	}
}

export const mainMenuWindowCaching = new MainMenuWindowCaching();

const MainMenuWindow = (props: MainMenuWindowConfig) => {
	const root = useRef(null);
	const [focusSet, setFocusSet] = useState(false);
	if(!focusSet) {
		Tools.getSaveData().then((retrievedData: CustomGameDataManager) => {
			if(retrievedData.data.isAnimationsEnabled) {
				setTimeout(() => {
					setFocus('main-menu-window-top');
				}, 1000);
			} else {
				setFocus('main-menu-window-top', null, 50);
			}
			
			setFocusSet(true);
		})
		
	}

	useEffect(() => {
		props.animation.updateProps({
			page: root.current
		});
	}, [root])

	return (
		<div ref={root} className={"modal-disable-select center-element main-menu-window-container " + props.animation.getInitialClass()} style={{
		}}>
			<PopUp1
				title= {constants.projectTitle}
				buttons={[
					{
						imgSrc: mainMenuWindowCaching.getItemByKey('start-scenarios-bs').src,
						idFor508: 'main-menu-window-top',
						width: '80%',
						height: '80px',
						buttonText: "Start Scenarios",
						hoverColor: '#bfddff',
						bgColor: undefined,
						onClick: props.onStartScenariosClicked
					},
					{
						imgSrc: mainMenuWindowCaching.getItemByKey('resume-game-bs').src,
						width: '80%',
						height: '80px',
						buttonText: "Resume Game",
						hoverColor: '#bfddff',
						bgColor: undefined,
						disabled: !props.isResumeUnlocked,
						onClick: props.onResumeGameClicked
					},
					{
						imgSrc: mainMenuWindowCaching.getItemByKey('settings-bs').src,
						width: '80%',
						height: '80px',
						buttonText: "Settings",
						hoverColor: '#bfddff',
						bgColor: undefined,
						onClick: props.onSettingsClicked
					},
					{
						imgSrc: mainMenuWindowCaching.getItemByKey('reference-materials-bs').src,
						width: '80%',
						height: '80px',
						buttonText: "Reference Materials",
						hoverColor: '#bfddff',
						bgColor: undefined,
						onClick: props.onReferenceMaterialsClicked
					}
				]}
				onRenderContent={() => {
					return (
						<div className='center-element-horizontal white-text' style={{
							textAlign:'center',
							width: '100%'
						}}>
							<h1>Main Menu</h1>
							<h2>Please select an option:</h2>
						</div>
				)}}></PopUp1>
		</div>
	);
};

export interface MainMenuWindowConfig extends BaseConfig {
	animation: AnimationPage;
	isResumeUnlocked: boolean;
	onStartScenariosClicked: () => void;
	onResumeGameClicked: () => void;
	onSettingsClicked: () => void;
	onReferenceMaterialsClicked: () => void;
}

export default MainMenuWindow;